import React, { Component } from "react";
import axios from "axios";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import moment from "moment";
import "react-dates/lib/css/_datepicker.css";
import CountrylistComp from "../CountrylistComp";
import CitylistComp from "../CitylistComp";
import { LoadingComp } from "../LoadingComp";
import PopupComp from "../PopupComp";
import constant from "../../constant";

import "./style.scss";

class EnquiryComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      isOpenEnquiry: false,
      isSuccess: false,
      isLoading: false,
      isSpaceType: 1,
      focusedInput: null,
      startDate: null,
      endDate: null,
      country_id: 0,
      city_id: 0,
      startTime: "00:00"
    };
  }

  handlePopup = () => {
    this.setState({
      isOpenEnquiry: !this.state.isOpenEnquiry
    });
  };

  handleClickSpaceType = e => {
    this.setState({ isSpaceType: parseInt(e.target.value) });
  };

  handleSubmit = e => {
    e.preventDefault();
    let errors = {};

    if (!e.target.fullname.value.match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)) {
      errors["fullname"] = "Enter only characters";
      e.target.fullname.focus();
      this.setState({
        errors
      });
      return;
    }
    let regx = /\b[a-zA-Z0-9\u00C0-\u017F._%+-]+@[a-zA-Z0-9\u00C0-\u017F.-]+\.[a-zA-Z]{2,}\b/;

    if (!e.target.email.value.match(regx)) {
      errors["email"] = "Enter valid Email Address";
      e.target.email.focus();
      this.setState({
        errors
      });
      return;
    }

    if (!e.target.phone.value.match(/^(\+\d{1,3}[- ]?)?\d{10}$/)) {
      errors["phone"] = "Enter valid phone number";
      e.target.phone.focus();
      this.setState({
        errors
      });
      return;
    }

    if (e.target.start_date.value === "") {
      errors["date"] = "Choose valid date";
      e.target.start_date.focus();
      this.setState({
        errors
      });
      return;
    }

    if (e.target.end_date.value === "") {
      errors["date"] = "Choose valid date";
      e.target.end_date.focus();
      this.setState({
        errors
      });
      return;
    }

    if (e.target.country_id.value === "0") {
      errors["country"] = "Choose country";
      e.target.country_id.focus();
      this.setState({
        errors
      });
      return;
    }

    if (e.target.city_id.value === "0") {
      errors["city"] = "Choose city";
      e.target.city_id.focus();
      this.setState({
        errors
      });
      return;
    }

    this.setState({
      errors: {},
      isLoading: true
    });

    let formData = new FormData(e.target);
    let _this = this;
    axios
      .post(
        `${constant.phpHost}action/ticket.php?todo=ticket_booking`,
        formData
      )
      .then(res => {
        // console.log(res);

        _this.setState({
          isLoading: false,
          isSuccess: true
        });

        setTimeout(() => {
          _this.refs.call_pop.handleRemoveClass();
          _this.setState({
            isSuccess: false
          });
        }, 3000);
      });
  };

  onDatesChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };

  onFocusChange = focusedInput => {
    this.setState({ focusedInput });
  };

  handleCountry = country_id => {
    this.setState({
      country_id: country_id,
      city_id: 0
    });
  };

  handleCity = city_id => {
    this.setState({
      city_id: city_id
    });
  };

  startTime = e => {
    this.setState({ startTime: e.target.value });
  };

  time_array = val => {
    var x = 30; //minutes interval
    var times = []; // time array
    var tt = 0; // start time

    if (val === "end_time") {
      let split_time = this.state.startTime.split(":");
      let t1 = parseInt(split_time[0]) * 60;
      let time_v = t1 + parseInt(split_time[1]);
      tt = time_v + 60;
    }

    //loop to increment the time and push results in array
    for (var i = 0; tt < 24 * 60; i++) {
      var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
      var mm = tt % 60; // getting minutes of the hour in 0-55 format
      times[i] = ("0" + (hh % 12)).slice(-2) + ":" + ("0" + mm).slice(-2);
      tt = tt + x;
    }

    return times;
  };

  render() {
    const BLOCK_DATES = [moment(), moment().add(1, "days")];
    const isDayBlocked = day =>
      BLOCK_DATES.filter(d => d.isSame(day, "day")).length > 0;

    let { errors, isSpaceType, isLoading, isSuccess } = this.state;

    function chk_errors(field) {
      return errors && errors[field] ? (
        <span
          style={{
            color: "red",
            display: "block",
            marginTop: 10
          }}
        >
          {errors[field]}
        </span>
      ) : null;
    }

    return (
      <section id="home-enquiry">
        <div className="text">
          <h2>Can’t find a space that meets your requirement ?</h2>
          <p>
            You may be a large enterprise or a startup or an individual, <br />
            our free customer service team can help you find the <br />
            best space for your business.
          </p>
          <button onClick={this.handlePopup}>Raise Ticket for Booking</button>
        </div>
        {this.state.isOpenEnquiry ? (
          <PopupComp ref="call_pop" isPopup={this.handlePopup}>
            <div className="form-group">
              <h2>Ticket Booking</h2>
              <p>Book your spaces in heydesk.com</p>
            </div>

            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Name *</label>
                <input
                  type="text"
                  name="fullname"
                  placeholder="Enter your name"
                />
                {chk_errors("fullname")}
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                />
                {chk_errors("email")}
              </div>

              <div className="form-group">
                <label>Phone No *</label>
                <input
                  type="text"
                  name="phone"
                  placeholder="Enter your phone number"
                  min="0"
                />
                {chk_errors("phone")}
              </div>

              <div className="cols-6 cols-xs-12">
                <div className="form-group">
                  <label>Space Type *</label>
                  <select
                    name="space_type"
                    onChange={this.handleClickSpaceType}
                    value={isSpaceType}
                  >
                    <option value="1">Desk</option>
                    <option value="2">Meeting room</option>
                    <option value="4">Cafe</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Attendees *</label>
                  <input
                    type="number"
                    name="no_of_people"
                    placeholder="No. of people"
                    defaultValue="1"
                    min="1"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Choose Date *</label>
                <DateRangePicker
                  startDateId="start_date"
                  endDateId="end_date"
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onDatesChange={this.onDatesChange}
                  focusedInput={this.state.focusedInput}
                  onFocusChange={this.onFocusChange}
                  numberOfMonths={1}
                  minimumNights={0}
                  displayFormat="DD-MM-YYYY"
                  isDayBlocked={isDayBlocked}
                />
                {chk_errors("date")}
              </div>
              {this.state.isSpaceType > 1 ? (
                <div className="cols-6">
                  <div className="form-group">
                    <label>Choose Time *</label>
                    <select name="start_time" onChange={this.startTime}>
                      {this.time_array("start_time").map((time, i) => (
                        <option key={i}>{time}</option>
                      ))}
                    </select>
                  </div>
                  <img
                    className="arrow"
                    src="assets/images/svg/picker_arrow_right.svg"
                    alt=""
                  />
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <select name="end_time" required>
                      {this.time_array("end_time").map((time, i) => (
                        <option key={i}>{time}</option>
                      ))}
                    </select>
                  </div>
                </div>
              ) : null}

              <div className="cols-6 cols-xs-12">
                <div className="form-group">
                  <label>Country *</label>
                  <CountrylistComp
                    handleCountry={this.handleCountry}
                    country_id={this.state.country_id}
                  />
                  {chk_errors("country")}
                </div>

                <div className="form-group">
                  <label>City *</label>
                  <CitylistComp
                    handleCity={this.handleCity}
                    city_id={this.state.city_id}
                    country_id={this.state.country_id}
                  />
                  {chk_errors("city")}
                </div>
              </div>

              <div className="form-group">
                <label>Preferred Area</label>
                <input type="text" name="pref_area" />
              </div>

              <div className="form-group">
                <label>Comments</label>
                <textarea
                  name="comments"
                  placeholder="Start's your comments here...."
                ></textarea>
              </div>

              <div className="form-group t-r">
                {isLoading ? (
                  <LoadingComp customStyle={{ padding: 0 }} />
                ) : isSuccess ? (
                  <p className="success">
                    Thank you for reaching us. We will get back to you soon.
                  </p>
                ) : (
                  <button>Submit</button>
                )}
              </div>
            </form>
          </PopupComp>
        ) : null}
      </section>
    );
  }
}
export default EnquiryComp;
